import { useRoute, type RouteProp } from '@react-navigation/native';
import React from 'react';
import { View } from 'react-native';
import { ServicePriceCard, Text } from '~/components';
import { TakesCareComponents } from '~/components/TakesCare';
import type { RootStackParamList } from '~/navigation/types';
import { formatMoney } from '~/utils';
import { marisaTakesCareResumeItems } from '~/utils/services';
import Footer from '../../components/Footer';
import GeneralConditionsButton from '../../components/GeneralConditionsButton';
import DefaultContainer from '../../components/DefaultContainer';
import { useUserInfoStore } from '~/stores/userInfo';

import { GENERAL_CONDITIONS_LINK } from '~/scenes/MarisaTakesCare/constants';
import RedeMaisSVG from '~/assets/svgs/redemais-logo.svg';

const HiredInsuranceCoverageTakesCare: React.FC = () => {
  const contractedServices = useUserInfoStore(
    (state) => state.user?.contractedServices
  );

  const {
    params: { id: certificateCode },
  } =
    useRoute<
      RouteProp<
        RootStackParamList,
        'MarisaServicos_HiredInsuranceCoverageTakesCare'
      >
    >();

  const contractedService = contractedServices?.find(
    (service) => service.certificateCode === certificateCode
  );

  if (!contractedService) return null;

  return (
    <DefaultContainer type="marisa-cuida" className="py-10">
      <Text className="text-gray-600 text-xl">
        Cobertura da Assistência Marisa Cuida
      </Text>

      <Text className="text-xs text-primary-600 mt-1 mb-6">
        Assistência Marisa Cuida
      </Text>

      <ServicePriceCard value={formatMoney(contractedService.value)} />

      <View className="mb-6">
        {marisaTakesCareResumeItems.map((item, index) => (
          <TakesCareComponents.ResumeItem {...item} key={index} />
        ))}
      </View>

      <GeneralConditionsButton
        className="mb-10"
        url={GENERAL_CONDITIONS_LINK}
      />

      <Footer icon={RedeMaisSVG} />
    </DefaultContainer>
  );
};

export default HiredInsuranceCoverageTakesCare;
